import axios from "axios";
import { LoggingConstants } from "Constants";
import { AxiosHelperSingleton, PendoHelperSingleton } from "Helpers";
import { TSavedQueryTempDTO, TTextAnalysisResponseDTO } from "Types";

export class SavedQueryController {

    public async create(caseId?: number, technologyId?: number): Promise<TSavedQueryTempDTO | null> {
        if(caseId) {
            PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SavedQueryCreateForCase`, {
                caseId: caseId
            });
            const response = await axios.post<TSavedQueryTempDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/savedquery/CreateForCase/${caseId}`);
            return response.data;
        } else if(technologyId) {
            PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SavedQueryCreateForTechnology`, {
                technologyId: technologyId
            });
            const response = await axios.post<TSavedQueryTempDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/savedquery/CreateForTechnology/${technologyId}`);
            return response.data;
        } else {
            return null;
        }
    }

    public async saveFirstDeliveryQueryChange(query: TSavedQueryTempDTO, attachType: string, attachId: number) {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SavedQueryFirstDeliveryChange`, {
            queryId: query.guid
        });
        
        const response = await axios.post<TSavedQueryTempDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/savedquery/${query.guid}/duplicate/${attachType}/${attachId}`);
        return response.data;
    }

    public async analyseTextAsync(text: string): Promise<TTextAnalysisResponseDTO> {
        const formData = new FormData();
        formData.append("text", `${text}`);

        PendoHelperSingleton.trackEvent(`${LoggingConstants.DYNAMIC_DELIVERY}AnalyzeText`);

        return (await axios.post(
            `${AxiosHelperSingleton.getServerBaseURL()}api/savedquery/analysetext`, 
            formData, 
            { headers: { "Content-Type": "multipart/form-data" } })).data;
    }
    
    public async rename(query: TSavedQueryTempDTO, name: string): Promise<boolean> {
        if(name.trim().length === 0) return true;

        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SavedQueryRename`, {
            queryId: query.guid
        });

        // TODO: really check the status code
        try {
            const formData = new FormData();
            formData.append("name", name);
            const response = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}api/savedquery/${query.guid}/rename`,
                formData);
            return response.status === 200;
        } catch {
            return false;
        }
    }

    public async delete(query: TSavedQueryTempDTO) : Promise<boolean>  {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SavedQueryDelete`, {
            queryId: query.guid
        });

        // TODO: really check the status code
        try {
            const response = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}api/savedquery/${query.guid}/delete`);
            return response.status === 200;
        } catch {
            return false;
        }
    }

    public async updateFilters(query: TSavedQueryTempDTO) : Promise<boolean>  {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SavedQueryUpdateFilters`, {
            queryId: query.guid
        });
        
        const response = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}api/savedquery/${query.guid}/filters`,
            query.filters);
        return response.status === 200;
    }
}

export const SavedQueryControllerSingleton = new SavedQueryController();